// extracted by mini-css-extract-plugin
export default {"redaction":"rKlKv0Hp","mobile":"mobile","editor":"SHUNcQq3","content":"wNz_TQ0E","jobTitle":"DD40tSng","email":"XU8oW224"};